import {
  MUTATION_RESPONSE_RECEIVED,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isResponseContainFlightsBody } from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';
import {
  getRadarFlightsResponseBody,
  isRadarFlightsResponseError,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/radarFlightsResponse';

import { mapAirportsStats } from './airportsStatsMapper';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { AirportsStats } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/airportsStats';

export const INITIAL_STATE: AirportsStats = {};

const airportsStats = (state: AirportsStats = INITIAL_STATE, action: Action): AirportsStats => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      switch (action.payload.type) {
        case RADAR_CREATE_SESSIONS:
        case RADAR_POLL: {
          if (
            isRadarFlightsResponseError(action.payload.response) ||
            !isResponseContainFlightsBody(action.payload.response)
          ) {
            return state;
          }

          const flightsResponseBody = getRadarFlightsResponseBody(action.payload.response);
          const airports = flightsResponseBody.filterStats?.airports;
          if (!airports) return state;
          return mapAirportsStats(airports);
        }

        default: {
          return state;
        }
      }
    }

    default:
      return state;
  }
};

export const get = (state: AirportsStats): AirportsStats => state;
export default airportsStats;
